import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import media from '../../styles/media.style';
import Placeholder from '../../components/Placeholder';
import { MOBILE_PADDING, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

const IntroSection = styled.section`
  margin: 0 auto 20px;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 0 ${MOBILE_PADDING}px;

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    margin: 0 auto 100px;
  `};
`;

const Title = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.3px;
  width: 100%;

  ${media.tabletL`
    font-size: 48px;
    font-weight: 500;
    line-height: 1.21;
    letter-spacing: 0.6px;
    max-width: 40%;
  `};
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: 0.1px;
  margin-top: 20px;
  white-space: pre-wrap;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.1px;
    margin-top: 0;
    max-width: 50%;
  `};
`;

const Intro = ({ title, description }) => (
  <IntroSection>
    <Title>{title || <Placeholder pb="10%" w="75%" />}</Title>
    <Description>{description || <Placeholder pb="20%" w="100%" />}</Description>
  </IntroSection>
);

Intro.defaultProps = {
  title: undefined,
  description: undefined,
};

Intro.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/IntroSection.js